import React from "react";
import PageHeader from "../../shared/components/PageHeader";
import useNavMenu from "../../shared/useNavMenu";

// Page-header definition for the legacy v1 School Profile pages. The tab list now
// resolves straight from the navigation registry (useNavMenu), permission-gated
// by the same server-computed map the nav menu reads (PageHeaderChrome hands it a
// NavProvider built from the page's `#app-props` blob). The active tab is matched
// against the current path, and each tab navigates through the bridge's navigate
// strategy: a v1 route stays in the legacy SPA via the page's guarded navigate, a
// v2 route is a hard cross-app nav. v1 no longer computes or passes these tabs.
export default function SchoolProfileHeader() {
  const { tabs, activeKey } = useNavMenu("school-profile");

  return (
    <PageHeader title="School Profile" tabs={tabs} activeTab={activeKey} />
  );
}
